<div class="menu-spotlight" (keydown)="onKeydown($event)">
  <div class="menu-spotlight__header">
    <mat-icon svgIcon="mat:search" class="menu-spotlight__search-icon"></mat-icon>
    <input
      #searchInput
      type="text"
      class="menu-spotlight__input"
      placeholder="Buscar menú..."
      [formControl]="query"
      autocomplete="off"
      spellcheck="false" />
    <kbd class="menu-spotlight__kbd">esc</kbd>
  </div>

  <div #listBody class="menu-spotlight__body">
    @if (filteredHits().length === 0) {
      <div class="menu-spotlight__empty">
        {{ query.value ? 'Sin resultados' : 'No hay menús disponibles' }}
      </div>
    } @else {
      <div class="menu-spotlight__section-label">Menús</div>
      <ul class="menu-spotlight__list" role="listbox">
        @for (hit of filteredHits(); track trackByRoute($index, hit); let i = $index) {
          <li
            role="option"
            [attr.aria-selected]="i === activeIndex()"
            class="menu-spotlight__item"
            [class.menu-spotlight__item--active]="i === activeIndex()"
            matRipple
            (click)="select(hit)"
            (mouseenter)="activeIndex.set(i)">
            <div class="menu-spotlight__item-icon">
              <mat-icon [svgIcon]="hit.icon || 'mat:chevron_right'"></mat-icon>
            </div>
            <div class="menu-spotlight__item-text">
              <div class="menu-spotlight__item-label">{{ hit.label }}</div>
              <div class="menu-spotlight__item-path">{{ hit.path }}</div>
            </div>
            <div class="menu-spotlight__item-route">{{ hit.route }}</div>
          </li>
        }
      </ul>
    }
  </div>

  <div class="menu-spotlight__footer">
    <span class="menu-spotlight__hint">
      <kbd>↑</kbd><kbd>↓</kbd>
      <span>navegar</span>
    </span>
    <span class="menu-spotlight__hint">
      <kbd>Enter</kbd>
      <span>abrir</span>
    </span>
    <span class="menu-spotlight__hint">
      <kbd>{{ shortcutHint }}</kbd>
      <span>abrir / cerrar</span>
    </span>
  </div>
</div>
